import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CounterAppSeqType } from '../../../../_models';
import { TranslateService } from '@ngx-translate/core';
import { TextboxConfig } from '../../../design-system/textbox/textbox.modal';
import { TextboxComponent } from '../../../design-system/textbox/textbox.component';
import { SharedModule } from '../../../../shared.module';
import { CommonModule } from '@angular/common';
import { TwoDigitDecimalNumberDirective } from '../../../../_directives/twoDigitDecimalNumber.directive';

@Component({
    selector: 'app-textbox-two-decimal-number',
    templateUrl: './textbox-two-decimal-number-renderer.component.html',
    standalone: true,
    imports: [TextboxComponent, SharedModule, CommonModule, TwoDigitDecimalNumberDirective]
})
export class TextboxTwoDecimalNumberComponent implements ICellRendererAngularComp {
  errReq: boolean = false;
  value: string;
  params: ICellRendererParams;
  isMandatory:boolean=false;
  isEnd:boolean=false;
  isVisible : boolean = false;
  placeholdertext: string = this.translate.instant('enter_amount_set_limit');

  constructor(private translate: TranslateService)
  {

  }

  textboxConfig: TextboxConfig = {
    id: '',
    placeholder: '',
    required: false,
    disabled: false,
    size: 'sm',
  };
      
  initilize(params: ICellRendererParams) {
    if (params.data) {
      this.params = params;
      this.value = '';
      if(Number(params.data.allowanceRate)>=0)
            this.value = params.data?.allowanceRate;
      if(Number(params.data.invoiceCALimit)>=0 && params.colDef.headerComponentParams 
      && params.colDef.headerComponentParams.fromVendor)
      {
        this.value = params.data?.invoiceCALimit;
      }
      if(Number(params.data.caLimit)>=0 && params.colDef.headerComponentParams 
      && !params.colDef.headerComponentParams.fromVendor)
      {
        this.value = params.data?.caLimit;
      }
                  
      if(Number(params.data.carbonFootprint) >= 0)
            this.value = params.data?.carbonFootprint;     
          
      if(Number(params.data.carbonFootprint) < 0)
      {    
        this.placeholdertext = (params.colDef.cellRendererParams?.placeholder)
          ? params.colDef.cellRendererParams.placeholder
          : this.translate.instant('enter_cev');              
      }
            
      if(Number(this.value)>=0)
           this.placeholdertext = '';

      this.isMandatory = params.data.sequence == CounterAppSeqType.Mandatory ; 
      this.isEnd = params.data.sequence == CounterAppSeqType.End;
      this.errReq = (this.value == '' || Number(this.value) < 0)|| params.data.errorRecord? true : false;
      if(this.errReq)
      {  
        this.placeholdertext = this.translate.instant('label_Required');
        this.value = '';
      }

      this.placeholdertext = (params.colDef.cellRendererParams?.placeholder)
          ? params.colDef.cellRendererParams.placeholder
          : this.translate.instant('enter_cev'); 
      this.textboxConfig = { ...this.textboxConfig, value: this.value, placeholder: this.placeholdertext, maxLength: params?.colDef?.cellRendererParams?.maxLength };
    }
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

  onChange(event) {
       this.value = event.target.value;
     this.textboxConfig = { ...this.textboxConfig, value: this.value };
     this.params.setValue(this.value);
    this.params.eGridCell.click();
  }

}
